// >>> NavbarDashboard.jsx COMPLETO — actualizado con comentarios

import React, { useState, useEffect } from 'react'; 
import './NavbarDashboard.css';
import { Link as Anchor, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHome, faUser, faBook, faImage, faChevronDown, faChevronUp, faCode, faClipboardList, faShoppingCart, 
    faGauge, faStore, faList, faRectangleList, faBuilding, faTag, faCog 
} from '@fortawesome/free-solid-svg-icons';  // >>> MODIFICACIÓN AÑADIDA AQUÍ
import { faProductHunt } from '@fortawesome/free-brands-svg-icons';
import { fetchUsuario, getUsuario } from '../../user';
import logo from '../../../images/logo.png';
import Logout from '../Logout/Logout';
import baseURL from '../../url';

export default function Navbar() {
    const location = useLocation();
    const [tienda, setTienda] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [detallesVisibles, setDetallesVisibles] = useState(false);
    const navigate = useNavigate();

    // >>> MODIFICACIÓN AÑADIDA AQUÍ — estado para el nuevo submenú de Configuración
    const [submenuConfig, setSubmenuConfig] = useState(false);

    const[submenProduct, setProduct] = useState (null);


    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const handleToggleNavbar = () => {
        setExpanded(!expanded);
    };

    const toggleDetalles = () => {
        setDetallesVisibles(!detallesVisibles)
    };
    const toggleProduct = () => {
        setProduct(!submenProduct)
    };




    // Trae usuario logueado
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };
        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    return (
        <div className={`navbarDashboard ${expanded ? 'expanded' : ''}`}>

            <Anchor className='logo' id='logo'>
                <div className='logo'>
                    {tienda?.imagen1 ? (
                        <img src={tienda?.imagen1} alt="logo" />
                    ) : (
                        <img src={logo} alt="logo" />
                    )}
                    <div className='deColumnNav'>
                        {tienda?.nombre ? <ss>{tienda?.nombre}</ss> : <ss>Tienda</ss>}
                        {tienda?.email ? <ss>{tienda?.email}</ss> : <ss>email@gmail.com</ss>}
                    </div>
                </div>
                <button onClick={handleToggleNavbar} className="nav_toggle2">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </Anchor>

            {loading ? (
                <></>
            ) : usuarioLegued?.idUsuario ? (
                <>
               

                    {usuarioLegued?.rol === 'admin' ? (
                        <div className='links'>

                            {/* Dashboard */}
                            <Anchor to={`/dashboard`} className={location.pathname === '/dashboard' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faGauge} /> Dashboard
                            </Anchor>

                            {/* Submenú Tienda */}
                            <div id='submenu'>
                                <button 
                                    id='btnSubmenu' 
                                    className={location.pathname === '/dashboard/mi-tienda' ? 'activeLinkBtn' : ''} 
                                    onClick={() => toggleDetalles()}
                                >
                                    <FontAwesomeIcon icon={faStore} /> <span id='btnLog'>Tienda</span>
                                    <div> {detallesVisibles ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}</div>
                                </button>

                                {detallesVisibles && (
                                    <div className='submenu'>
                                        <button
                                            onClick={() => navigate('/dashboard/mi-tienda')}
                                            className={location.pathname === '/dashboard/mi-tienda' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                        >
                                            Información de mi tienda
                                        </button>
                                        <button
                                            onClick={() => navigate('/dashboard/metodos-de-pago')}
                                            className={location.pathname === '/dashboard/metodos-de-pago' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                        >
                                            Métodos de pago
                                        </button>
                                    </div>
                                )}
                            </div>

                           


                              {/*NEW SUB MENU */}

                            <div id='submenu'>
                                <button 
                                    id='btnSubmenu' 
                                    className={location.pathname === '/dashboard/productos' ? 'activeLinkBtn' : ''} 
                                    onClick={() => toggleProduct()}
                                >
                                    <FontAwesomeIcon icon={faProductHunt} /> <span id='btnLog'>Productos</span>
                                    <div> {submenProduct ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}</div>
                                </button>

                                {submenProduct && (
                                    <div className='submenu'>
                                        <button
                                            onClick={() => navigate('/dashboard/productos')}
                                            className={location.pathname === '/dashboard/productos' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                        >
                                            Crear Producto
                                        </button>
                                        <button
                                            onClick={() => navigate('/dashboard/categorias')}
                                            className={location.pathname === '/dashboard/categorias' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                        >
                                            Categorías
                                        </button>
                                        <button
                                            onClick={() => navigate('/dashboard/atributos')}
                                            className={location.pathname === '/dashboard/atributos' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                        >
                                            Conjuntos de Atributos
                                        </button>
                                        <button
                                            onClick={() => navigate('/dashboard/atributos/info')}
                                            className={location.pathname === '/dashboard/atributos/info' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                        >
                                            Información de Atributos
                                        </button>
/info




                                    </div>
                                )}
                            </div>
                             


                                                             <Anchor
                                  to="/dashboard/marcas"
                                  className={location.pathname === '/dashboard/marcas' ? 'activeLink' : ''}>
                                  🏷️ Marcas
                                </Anchor>

                                <Anchor
                                  to="/dashboard/resenas"
                                  className={location.pathname === '/dashboard/resenas' ? 'activeLink' : ''}>
                                  ⭐ Reseñas
                                </Anchor>

                                <Anchor
  to="/dashboard/apariencia"
  className={location.pathname === '/dashboard/apariencia' ? 'activeLink' : ''}>
  🎨 Apariencia
</Anchor>







                            <Anchor to={`/dashboard/pedidos`} className={location.pathname === '/dashboard/pedidos' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faRectangleList} /> Pedidos
                            </Anchor>
                            <Anchor to={`/dashboard/banners`} className={location.pathname === '/dashboard/banners' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faImage} /> Banners
                            </Anchor>
                            <Anchor to={`/dashboard/promociones`} className={location.pathname === '/dashboard/promociones' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faTag} /> Promociones
                            </Anchor>
                            <Anchor to={`/dashboard/usuarios`} className={location.pathname === '/dashboard/usuarios' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faUser} /> Usuarios
                            </Anchor>

                            {/* >>> MODIFICACIÓN AÑADIDA AQUÍ — Nuevo botón Configuración con submenú */}
                            <div id='submenu'>
                                <button
                                    id='btnSubmenu'
                                    onClick={() => setSubmenuConfig(!submenuConfig)}  // <<< Toggle submenú
                                    className={location.pathname.includes('/dashboard/configuracion') ? 'activeLinkBtn' : ''}
                                >
                                    <FontAwesomeIcon icon={faCog} /> <span id='btnLog'>Configuración</span>
                                    <div> {submenuConfig ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}</div>
                                </button>

                                {/* >>> Aquí se agregó el nuevo botón "Mensaje de WhatsApp" */}
                                {submenuConfig && (
                                    <div className='submenu'>
                                        <button
                                            onClick={() => navigate('/dashboard/configuracion/whatsapp')}
                                            className={location.pathname === '/dashboard/configuracion/whatsapp' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                        >
                                            Mensaje de WhatsApp
                                        </button>

                                        <button
                                            onClick={() => navigate('/dashboard/developer')}
                                            className={location.pathname === '/dashboard/developer' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                        >
                                            Developer
                                        </button>





                                    </div>
                                )}
                            </div>


                            {/* >>> FIN MODIFICACIÓN  NUEVA UPATE*/}

                           <Anchor to={`/dashboard/sucursales`} className={location.pathname === '/dashboard/sucursales' ? 'activeLink' : ''}
                            >
                           <FontAwesomeIcon icon={faBuilding} /> Sucursales
                          </Anchor>






                            <Logout />
                        </div>
                    ) : usuarioLegued?.rol === 'colaborador' ? (
                        <div className='links'>
                            {/* Colaborador */}
                            <Anchor to={`/dashboard`} className={location.pathname === '/dashboard' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faGauge} /> Dashboard
                            </Anchor>
                            <Anchor to={`/dashboard/categorias`} className={location.pathname === '/dashboard/categorias' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faList} /> Categorías
                            </Anchor>
                            <Anchor to={`/dashboard/productos`} className={location.pathname === '/dashboard/productos' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faProductHunt} /> Productos
                            </Anchor>
                            <Anchor to={`/dashboard/pedidos`} className={location.pathname === '/dashboard/pedidos' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faRectangleList} /> Pedidos
                            </Anchor>
                        </div>
                    ) : (
                        <div className='links'>
                            {/* Otros usuarios */}
                            <Anchor to={`/dashboard`} className={location.pathname === '/dashboard' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faGauge} /> Dashboard
                            </Anchor>
                            <Anchor to={`/dashboard/pedidos`} className={location.pathname === '/dashboard/pedidos' ? 'activeLink' : ''}>
                                <FontAwesomeIcon icon={faRectangleList} /> Pedidos
                            </Anchor>
                        </div>
                    )}
                </>
            ) : (
                <div className='links'>
                    {/* Usuarios no logueados */}
                    <Anchor to={`/dashboard`} className={location.pathname === '/dashboard' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faGauge} /> Dashboard
                    </Anchor>

                    {/* Submenú Tienda */}
                    <div id='submenu'>
                        <button id='btnSubmenu' className={location.pathname === '/dashboard/mi-tienda' ? 'activeLinkBtn' : ''} onClick={() => toggleDetalles()}>
                            <FontAwesomeIcon icon={faStore} /> <span id='btnLog'>Tienda</span>
                            <div> {detallesVisibles ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}</div>
                        </button>

                        {detallesVisibles && (
                            <div className='submenu'>
                                <button
                                    onClick={() => navigate('/dashboard/mi-tienda')}
                                    className={location.pathname === '/dashboard/mi-tienda' ? 'activeLinkBtn2' : 'desactiveLinkBtn'}
                                >
                                    Información de mi tienda
                                </button>
                                <button
                                    onClick={() => navigate('/dashboard/metodos-de-pago')}
                                    className={location.pathname === '/dashboard/metodos-de-pago' ? 'activeLinkBtn2' : 'desactiveLinkBtn'}
                                >
                                    Métodos de pago
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Otros links */}
                    <Anchor to={`/dashboard/categorias`} className={location.pathname === '/dashboard/categorias' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faList} /> Categorías
                    </Anchor>
                    <Anchor to={`/dashboard/productos`} className={location.pathname === '/dashboard/productos' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faProductHunt} /> Productos
                    </Anchor>
                    <Anchor to={`/dashboard/pedidos`} className={location.pathname === '/dashboard/pedidos' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faRectangleList} /> Pedidos
                    </Anchor>
                    <Anchor to={`/dashboard/banners`} className={location.pathname === '/dashboard/banners' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faImage} /> Banners
                    </Anchor>
                    <Anchor to={`/dashboard/promociones`} className={location.pathname === '/dashboard/promociones' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faTag} /> Promociones
                    </Anchor>
                    <Anchor to={`/dashboard/usuarios`} className={location.pathname === '/dashboard/usuarios' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faUser} /> Usuarios
                    </Anchor>

                    {/* >>> MISMA MODIFICACIÓN PARA USUARIOS SIN LOGIN (opcional) */}
                    <div id='submenu'>
                        <button
                            id='btnSubmenu'
                            onClick={() => setSubmenuConfig(!submenuConfig)}
                            className={location.pathname.includes('/dashboard/configuracion') ? 'activeLinkBtn' : ''}
                        >
                            <FontAwesomeIcon icon={faCog} /> <span id='btnLog'>Configuración</span>
                            <div> {submenuConfig ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}</div>
                        </button>

                        {submenuConfig && (
                            <div className='submenu'>
                                <button
                                    onClick={() => navigate('/dashboard/configuracion/whatsapp')}
                                    className={location.pathname === '/dashboard/configuracion/whatsapp' ? 'activeLinkBtn' : 'desactiveLinkBtn'}
                                >
                                    Mensaje de WhatsApp
                                </button>
                            </div>
                        )}
                    </div>
                    {/* >>> FIN MODIFICACIÓN */}

                    <Logout />
                </div>
            )}

        </div>
    );
}
